var resources = require('items-view-strings');
    var strings = resources['_v/GK+NZpu1FoG+ltQ7Azjg'];
export { strings };
export default strings;
